import React from 'react';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
import { TimerSvg } from './Svgs';
import dateTimeFormat from 'legacy-src/utility/DateTime';

import './ExitAssignmentModal.scss';

/**
 * Renders the modal for exiting an assignment while taking it.
 * This is a confirmation modal for student.
 * */
const ExitAssignmentModal = ({
  isSoftTime,
  onSubmit,
  onClose,
  timer,
  dueAt,
  timezone,
  allowLateSubmissionFF,
}) => {
  const dueAtDate = dateTimeFormat(dueAt, 'dateMonthTextAndDay', timezone);
  const dueAtHour = dateTimeFormat(dueAt, 'timeHourSeconds', timezone);

  const lateSubmissionText = allowLateSubmissionFF
    ? `page in your Assignments, unless your teacher has chosen to allow for late submissions`
    : `view of “Assignments” at that time`;

  return (
    <ConfirmDialog
      size="small"
      title="Save and Exit"
      onClose={onClose}
      onSuccess={(args) => {
        onSubmit(args);
      }}
      aria={{
        'aria-live': 'polite',
      }}
      content={{
        btnPrimary: 'Yes',
        btnSecondary: 'No',
      }}
    >
      {dueAt ? (
        timer ? (
          <div className="flex flex-col gap-8">
            <div className="flex gap-4 items-center">
              <p className="m-0">
                This is a timed assignment that is due on {dueAtDate} at{' '}
                {dueAtHour}.
              </p>
            </div>
            <p className="m-0">
              If you exit now, your progress will be saved and the timer will
              continue to run. If you don’t submit this assignment before the
              due date, it will be automatically submitted at that time and
              moved to your “Completed” {lateSubmissionText}.
            </p>
            <p className="m-0">Do you want to exit the assignment?</p>
          </div>
        ) : (
          <div className="flex flex-col gap-8">
            <p className="m-0">
              Your progress has been saved, and you have not yet submitted the
              assignment.
            </p>
            <p className="m-0">
              This assignment is due on {dueAtDate} at {dueAtHour}. If you don’t
              submit it before then, it will be automatically submitted and
              moved to your “Completed” {lateSubmissionText}.
            </p>
            <p className="m-0">Do you want to exit the assignment?</p>
          </div>
        )
      ) : timer ? (
        <div className="flex flex-col gap-8">
          <div className="flex gap-4 items-center">
            {isSoftTime && <TimerSvg />}
            <p className="m-0">This is a timed assessment.</p>
          </div>
          <p className="m-0">
            If you leave now, the timer will continue to run and your response
            will not be submitted.
          </p>
          <p className="m-0">Are you sure you want to leave this page?</p>
        </div>
      ) : (
        <div className="flex flex-col gap-8">
          <p className="m-0">Your progress has been saved.</p>
          <p className="m-0">You have not yet submitted the assignment.</p>
          <p className="m-0">Do you want to exit the assignment?</p>
        </div>
      )}
    </ConfirmDialog>
  );
};

export default ExitAssignmentModal;
